import InventoryAllocation from "@/onboarding/features/inventory_allocation/InventoryAllocation"
import Slice from "@/onboarding/features/inventory_allocation/Slice"
import { withApp } from "@/components/App"

export default withApp(InventoryAllocation, { slices: [Slice] })
